import React, { createContext, useContext, ReactNode } from "react";

type SecondaryMarketContextType = {
  userSignedIn: boolean;
  investorId?: number;
};

const SecondaryMarketContext = createContext<
  SecondaryMarketContextType | undefined
>(undefined);

type SecondaryMarketProviderProps = {
  children: ReactNode;
  userSignedIn: boolean;
  investorId?: number;
};

export const SecondaryMarketProvider = ({
  children,
  userSignedIn,
  investorId,
}: SecondaryMarketProviderProps) => {
  const value: SecondaryMarketContextType = {
    userSignedIn,
    investorId,
  };

  return (
    <SecondaryMarketContext.Provider value={value}>
      {children}
    </SecondaryMarketContext.Provider>
  );
};

export const useSecondaryMarket = () => {
  const context = useContext(SecondaryMarketContext);
  if (!context) {
    throw new Error(
      "useSecondaryMarket must be used within a SecondaryMarketProvider"
    );
  }
  return context;
};
